import { styled, Link, Typography, Button, Paper } from "@mui/material";

export const StyledFooter = styled("footer")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  width: "100%",
  padding: theme.spacing(2),
  fontSize: "0.875rem",
  marginTop: "1em",

  ["& a"]: {
    color:
      theme.palette.mode === "dark"
        ? theme.custom.palette.blue[300]
        : theme.custom.palette.blue[500],
  },
}));

export const HelpLink = styled(Link)(({ theme }) => ({
  color:
    theme.palette.mode === "dark" ? theme.custom.palette.blue[300] : theme.custom.palette.blue[500],
}));

export const TypeContainer = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const PaperContainer = styled(Paper)(({ theme }) => ({
  padding: "1em",
  borderRadius: "8px",
  marginTop: theme.spacing(3),
  border:
    theme.palette.mode === "dark"
      ? "1px solid " + theme.palette.grey[700]
      : "1px solid " + theme.custom.palette.blueGrey[100],
  boxShadow: "none",
}));

export const LoadMoreButton = styled(Button)(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.custom.palette.blue[300] : theme.custom.palette.blue[500],
  color: theme.palette.mode === "dark" ? theme.palette.grey[800] : "#fff",
}));
